export default "__VITE_ASSET__2f328333__"